<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            <!--<router-link :to="{path:'/admin'}">Dashboard</router-link>-->
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        Coded with &nbsp; <i class="ti-heart heart"></i> &nbsp; by 4Sight
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
